import { CUSTOM_ELEMENTS_SCHEMA, NgModule }                    from '@angular/core';
// Modules
import { SharedModule } from './../shared/shared.module';
import { GlobalSettingsRoutingModule } from './global-settings-routing.module';
// Components
import { GlobalSettingsComponent } from './global-settings.component';
import { AdministratorsComponent } from './administrators/administrators.component';
import { EditionSettingsComponent } from './edition-settings/edition-settings.component';
import { SSOSettingsComponent }     from './auth-settings/sso-settings.component';
import { ViewSSOSettingsComponent } from './auth-settings/view-sso-settings.component';
import { ProviderListComponent }    from './auth-settings/provider-list.component';
import { AddGlobalAdminsComponent } from './administrators/add-global-admins/add-global-admins.component';
// Services
import { AdminService } from './administrators/admin.service';
import { AuthSettingsService } from './auth-settings/auth-settings.service';
import { UserPermissionRoleListComponent } from './permission-settings/user-permission-role-list.component';
import { UserPermissionRoleComponent } from './permission-settings/user-permission-role.component';

@NgModule({
  imports: [
    SharedModule,
    GlobalSettingsRoutingModule
  ],
  declarations: [
    GlobalSettingsComponent,
    AdministratorsComponent,
    EditionSettingsComponent,
    AddGlobalAdminsComponent,
    SSOSettingsComponent,
    ViewSSOSettingsComponent,
    ProviderListComponent,
    UserPermissionRoleListComponent,
    UserPermissionRoleComponent,
  ],
  providers: [ AdminService, AuthSettingsService ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})

export class GlobalSettingsModule { }



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/global-settings.module.ts